import type { WorkflowServiceConfig } from 'flow/store/engine/types';
import { CredentialOwner } from '~/dashboard/views/settings/service-configuration/types';

export function makeServiceConfig(
  overrides: Partial<WorkflowServiceConfig> = {},
): WorkflowServiceConfig {
  return {
    selectedAlloyOptions: { serviceConfigOptions: [] },
    selectedCustomerOptions: { credentialOwner: CredentialOwner.unknown, serviceConfigOptions: [] },
    serviceConfigOptions: [],
    ...overrides,
  };
}
